var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.5 58.5c0 2.485-2.686 4.5-6 4.5s-6-2.015-6-4.5 2.686-4.5 6-4.5 6 2.015 6 4.5M44.5 1c-8.8 0-11.667 6-12 9-.833-3-4.8-9-14-9C7 1 5 12.5 5 16s3.133 9.817 8.5 12.5c7 3.5 13.333 13 16.5 19.5.167.667.9 2 2.5 2s2.333-1.333 2.5-2c2.5-8.5 9-17 15.5-19.5s9-7 9-12.5-4-15-15-15"
  })));
};
export default SvgHeart;